import { render, staticRenderFns } from "./AuditStatusGroupPost.vue?vue&type=template&id=2aa6983f&scoped=true&"
import script from "./AuditStatusGroupPost.vue?vue&type=script&lang=js&"
export * from "./AuditStatusGroupPost.vue?vue&type=script&lang=js&"
import style0 from "./AuditStatusGroupPost.vue?vue&type=style&index=0&id=2aa6983f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa6983f",
  null
  
)

export default component.exports